export default "__VITE_ASSET__BpYDUtu5__"